const SearchQueryKeys = {
  global: ["search"] as const,

  all: (q: string, type: string) =>
    [...SearchQueryKeys.global, "all", type, q] as const,
  hashtags: (q: string) => [...SearchQueryKeys.global, "hashtags", q] as const,
};

export { SearchQueryKeys };
